import {Injectable} from '@angular/core';
import {EMPTY, Observable} from 'rxjs';
import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {environment} from '../../environments/environment';
import {TenantService} from '../services/tenant.service';

@Injectable({providedIn: 'root'})
export class TenantInterceptor implements HttpInterceptor {

  constructor(private tenant: TenantService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (!req.url.startsWith(environment.apiUrl) || req.url.includes('/platform/')) {
      return next.handle(req);
    }

    const doubleSlash = `${environment.apiUrl}//`;
    if (!req.url.includes(doubleSlash)) {
      return next.handle(req); // public endpoint, no tenant prefix needed
    }

    const slug = this.tenant.slug;
    if (!slug) {
      return EMPTY; // tenant-scoped call without a slug — suppress to avoid a 401 reload loop
    }

    const newUrl = req.url.replace(doubleSlash, `${environment.apiUrl}/${slug}/`);
    return next.handle(req.clone({url: newUrl}));
  }
}
